/**
 * Central registry of in-app guided tours (driver.js).
 *
 * To add a tour: add one member below and call `useSeenTour(TourKey.X)` where the
 * tour runs. The string VALUES are persisted in BE role preferences
 * (`settings.seenTours`), so keep them stable even if the member name changes.
 */
export enum TourKey {
  PbsDrillDownCell = 'pbsDrillDownCell',
  PbsCellDrillDownModal = 'pbsCellDrillDownModal',
  DataUploadFolderPermissions = 'dataUploadFolderPermissions',
  DataUploadFileBrowser = 'dataUploadFileBrowser',
}
